import {
  ExpoRouterDemoBackButton,
  ExpoRouterDemoScreen,
  ExpoRouterDemoTitle,
} from '../../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <ExpoRouterDemoScreen>
      <ExpoRouterDemoTitle>Addresses</ExpoRouterDemoTitle>
      <ExpoRouterDemoBackButton />
    </ExpoRouterDemoScreen>
  );
}
